import { Button, Icon } from "@chakra-ui/react";
import React from "react";
import { FaArrowRight } from "react-icons/fa";

type ToolDescriptionCardProps = {
  title: string;
  actionText: string;
  actionTextWidthPercentage?: string;
  description: string;
  ctaText: string;
  handleCTAClick: () => void;
};
export default function ToolDescriptionCard({
  title,
  actionText,
  actionTextWidthPercentage,
  description,
  ctaText,
  handleCTAClick,
}: ToolDescriptionCardProps) {
  return (
    <div className="w-full h-full flex flex-col border-[#121212] border-[1px]">
      <div className="px-4 py-8 lg:px-8 lg:py-12 w-full border-[#121212] border-b-[1px]">
        <h4 className="text-lg lg:text-3xl font-semibold text-[#173241]">
          {title.toUpperCase()}
        </h4>
      </div>
      <div className="bg-[#A1CAE1] px-4 py-8 lg:px-8 lg:py-12 w-full border-[#121212] border-b-[1px]">
        <h3
          className={`lg:w-[${
            actionTextWidthPercentage || "90%"
          }] font-medium text-xl lg:text-5xl text-[#0E1E27] lg:leading-[56px]`}
        >
          {actionText}
        </h3>
      </div>
      <div className="px-4 py-8 lg:px-8 lg:py-12 w-full">
        <p className="w-full text-base lg:text-2xl lg:leading-[39px] text-[#121212]">
          {description}
        </p>
      </div>
      <div className="self-end px-4 py-8 lg:px-8 lg:py-12 w-full">
        <Button
          alignSelf={"start"}
          px={1}
          rightIcon={
            <Icon
              as={FaArrowRight}
              w={{
                base: 3,
                lg: 4,
              }}
              fontSize={{
                base: "18px",
                lg: "26px",
              }}
              h={4}
              ml={0}
            />
          }
          variant={"ghost"}
          onClick={handleCTAClick}
        >
          {ctaText}
        </Button>
      </div>
    </div>
  );
}
